import { FC } from 'react';
import { Box, Button, Divider, styled, Typography } from '@mui/material';
import useSurveyNavigate from '@/hooks/useSurveyNavigate';
import clothesImage from '@/assets/images/clothes.png';
import timeImage from '@/assets/images/time.png';
import makeupImage from '@/assets/images/makeup.png';
import moneyImage from '@/assets/images/money.png';
import Agreement from '@/components/Agreement';
import { ReactComponent as CustomUnderline } from '@/assets/images/custom-underline.svg';

const TAGS = [
  {
    image: clothesImage,
    name: 'Fashion edits,',
  },
  {
    image: makeupImage,
    name: 'Beauty glow-ups,',
  },
  {
    image: timeImage,
    name: 'Decor tips,',
  },
  {
    image: moneyImage,
    name: 'Budget finds',
  },
  {
    name: '& more',
  },
];

const Container = styled(Box)(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

const Image = styled('img')(() => ({
  width: 20,
  height: 20,
}));

const Underline = styled(CustomUnderline)(() => ({
  position: 'absolute',
  top: 35,
  left: '50%',
  transform: 'translateX(-50%)',
}));

const CustomDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.border.main,
  height: 1,
  borderBottomWidth: 0,
}));

const Footer = styled('footer')(() => ({
  gap: 16,
  paddingBottom: 16,
  display: 'flex',
  flexDirection: 'column',
}));

const GetStartedPage: FC = () => {
  const { next } = useSurveyNavigate();

  return (
    <Container>
      <Box
        flex={1}
        gap={2}
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Typography
          fontSize={36}
          fontWeight={700}
          lineHeight="40px"
          whiteSpace="pre-line"
          textAlign="center"
          position="relative"
        >
          <Underline />
          {'Get up to $500 \nback on your \nshopping'}
        </Typography>
        <Box maxWidth={288} gap={1} display="flex" flexWrap="wrap" justifyContent="center">
          {TAGS.map((item, index) => (
            <Box key={index} gap={0.25} display="flex" alignItems="center">
              {item.image && <Image src={item.image} />}
              <Typography fontWeight={600}>{item.name}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
      <Footer>
        <Agreement />
        <CustomDivider />
        <Box paddingInline={2} flex={1} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            onClick={next}
            variant="contained"
            size="large"
            sx={{ maxWidth: 600, width: '100%' }}
          >
            Continue
          </Button>
        </Box>
      </Footer>
    </Container>
  );
};

export default GetStartedPage;
